import FormItem from 'antd/lib/form/FormItem'
import './index.less'

export default FormItem



// WEBPACK FOOTER //
// ./src/elements/form-item/index.js